import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {AppConfig} from '../../app.config';
@Injectable()
export class DocumentsService {
  constructor (private http: HttpClient , private api: AppConfig) {

  }

  getDocuments (id, type) {
    return this.http.get(this.api.baseUrl + '/document/documents?type=' + type + '&id=' + id + '&project=back' , this.api.jsonTokenHeaders);
  }

  uploadDocument (data) {
    // console.log(data);
    const formData: FormData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key) && data[ key ] && key !== 'files') {
        formData.append(key , data[ key ]);
      }

      if (data.hasOwnProperty(key) && !data[ key ] && !key.includes('Id')) {
        formData.append(key , '');
      }
    }

    for (let i = 0; i < data.files.length; i++) {
      formData.append('files' , data.files[ i ].file);
    }

    return this.http.post(this.api.baseUrl + '/document/addDocument' , formData , this.api.formDataHeaders);
  }

  uploadElDocument (data) {
    // console.log(data);
    const formData: FormData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key) && data[ key ] && key !== 'files') {
        formData.append(key , data[ key ]);
      }

      if (data.hasOwnProperty(key) && !data[ key ] && !key.includes('Id')) {
        formData.append(key , '');
      }
    }

    for (let i = 0; i < data.files.length; i++) {
      formData.append('files' , data.files[ i ]);
    }

    return this.http.post(this.api.baseUrl + '/document/addElearningDocument' , formData , this.api.formDataHeaders);
  }

  addBigDocument(data) {
    return this.http.post(this.api.baseUrl + '/document/addBigDocument' , data , this.api.formDataHeaders);
  }

  addYoutube(data) {
    return this.http.post(this.api.baseUrl + '/document/addYoutube' , data , this.api.formDataHeaders);
  }

  deleteDocument(id) {
    return this.http.get(this.api.baseUrl + '/document/deleteDocument?id=' + id , this.api.jsonTokenHeaders);
  }

  updateAccess(id, state) {
    return this.http.get(this.api.baseUrl + '/document/updateAccess?id=' + id + '&state=' + state , this.api.jsonTokenHeaders);
  }

  getVideoStream(name) {
    return this.api.baseUrl + '/document/getVideoStream/' + name;
  }

  getFileStream(name) {
    if (name) {
      return this.api.baseUrl + '/document/getFilesStream/' + name;
    }
  }

  getFiles(name) {
    return this.http.get(this.api.baseUrl + '/document/getFiles?name=' + name);
  }
}
